import React from 'react';
import NCredito from 'components/Tvendo/Sale/Operations/NCredito/NCSharedFile';

export default function () {
  return <NCredito type="NCN" title="NC normal" />;
}
